import { render, staticRenderFns } from "./game-summary.vue?vue&type=template&id=ef289ec4&scoped=true&"
import script from "./game-summary.vue?vue&type=script&lang=js&"
export * from "./game-summary.vue?vue&type=script&lang=js&"
import style0 from "./game-summary.vue?vue&type=style&index=0&id=ef289ec4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef289ec4",
  null
  
)

export default component.exports